import { Inject, Injectable } from '@angular/core';
import { Language } from '@interface/language';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Observable} from 'rxjs';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import Utils from '../core/utils/utils';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private languages: Language[];
  private defaultLanguage: Language;
  private language: Language;
  public subscription$: Observable<any>;

  constructor(
      public translateService: TranslateService,
      @Inject(LOCAL_STORAGE) public storage: WebStorageService,
      private bsLocaleService: BsLocaleService
  ) {
    this.languages = [
      { name: 'Português (Brasil)', code: 'pt-BR', translate: 'languages.pt' },
      { name: 'English', code: 'en', translate: 'languages.en' },
      { name: 'Español', code: 'es', translate: 'languages.es' }
    ];

    this.defaultLanguage = this.languages[0];

    this.subscription$ = this.translateService.onLangChange;
  }


  setLanguageCode(code: string): Language {
    this.language = this.languages.find((l: Language) => l.code === code);
    if (!this.language) {
      this.language = this.getDefaultLanguage();
    }

    this.translateService.setDefaultLang(this.language.code);
    this.storage.set('language', this.language);
    this.bsLocaleService.use(this.language.code);

    this.translateService.onLangChange.emit({lang: this.language.code} as LangChangeEvent);

    return this.language;
  }

  getLanguage(): Language {
    if (!this.language) {
      const language = this.storage.get('language');

      if (language) {
        this.language = language;
      }
    }

    return this.language ? this.language : this.getDefaultLanguage();
  }

  getLanguages(): Language[] {
    return this.languages;
  }

  getDefaultLanguage(): Language {
    return this.defaultLanguage;
  }

  async translate(value: string): Promise<string> {
    return await this.translateService.get(value).toPromise();
  }

  async translateBackendMessage(value: string): Promise<string> {
    if (Utils.isNumeric(value)) {
      let backendMessage = await this.translateService.get(`backendMessages.error_${value}`).toPromise();
      backendMessage = backendMessage.indexOf('backendMessages') >= 0 ?
          await this.translateService.get(`backendMessages.unknown`).toPromise() :
          backendMessage
      return backendMessage;
    } else {
      return value;
    }
  }

  async translateAPIBackendMessage(exception: any, defaultMessage: string): Promise<string> {
    const errorCode = exception?.error?.erro?.body?.code;
    let errorMessage = exception?.error?.erro?.body?.message;
    if (!errorMessage) {
      errorMessage = exception?.error?.message;
    }
    let message = '';

    if (Utils.isNumeric(errorCode)) {
      message = await this.translateService.get(`backendMessages.new_api_${errorCode}`).toPromise();
      message = message.indexOf('backendMessages') >= 0 ?
          await this.translateService.get(defaultMessage).toPromise() :
          message;
    } else {
      message = await this.translateService.get(defaultMessage).toPromise();
      if (errorMessage) {
        message = `${message} (${errorMessage})`;
      }
    }

    return message;
  }
}
